import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import Loading from './Loading';

export default function ServerRouteGate({ workflow, action, children }) {
  const session = useSelector((state) => state.sessions.get('session'));

  if (!session || !session.workflow || !session.action) {
    return <Loading />;
  }

  if (session.workflow === workflow && session.action === action) {
    return children;
  }

  return <Redirect to={`/${session.workflow}/${session.action}`} />;
}
